import PropertyAdForm from "../../../../components/forms/propertyAdform";
import { useCreatePropertyMutation } from "../../../../features/property/propertyApiSlice";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CreateSingleProperty = () => {
  const { name } = useSelector((state) => state.user);
  const img_name = localStorage.getItem("firebaseImage");
  const [propertyadd, setPropertyadd] = useState({
    companyid: "",
    userid: name?._id,
    country: "",
    city: "",
    state: "",
    area: "",
    contactnumber: "",
    email: "",
    price: "",
    saletype: "",
    description: "",
    image: img_name,
    status: true,
  });
  const navigate = useNavigate();
  const [createProperty] = useCreatePropertyMutation();

  const formSubmit = (e) => {
    e.preventDefault();
    createProperty(propertyadd)
      .unwrap()
      .then(async (response) => {
        if (response?.success) {
          setTimeout(() => {
            SuccessNotify("Add Posted SuccesFully...");
            navigate(`/personal-add`);
          }, 3000);
        }
      })
      .catch((error) => {
        FailedNotify("Failed to Post Try Again!");
      });
  };


  return (
    <div>
      <PropertyAdForm
        title="Create Personal Property Category,Location,Price,Description"
        butn="Post"
        navigateTo="/personal-add"
        back="/SellingSide"
        propertyadd={propertyadd}
        setPropertyadd={setPropertyadd}
        handlerFunction={formSubmit}
      />
    </div>
  );
};
export default CreateSingleProperty;
